<div class="popup">
    <div class="part1">
        <p style="color:rgb(128, 42, 183);font-size:0.8rem">SNAPSHOT LAYOUT</p>
        <img src="../../../../assets/images/common/close-icon.svg" alt="" class="closeImg"
            (click)="collapseLayoutPopup()">
    </div>
    <hr class="heading-hr">
    <div class="part2">
        <div class="popupBody">
            <div class="layout-intro">
                <p style="font-size:0.7rem;">Total Widgets Configured: {{widgetConfigured}}</p>
                <hr class="custom-hr">
            </div>
            <div class="layout-dropdown">

                <div *ngFor="let page of pages; let i = index" class="dropdown-container"  >
                    <div style="width:7%">
                        <span [class.DNN]="page.disabled" style="font-size:0.7rem">{{ page.page }}</span>
                    </div>
                    <div class="dropdown" [class.DNN]="page.disabled" >
                        <div class="dropdown-toggle" (click)="toggleDropdown(i)" [ngClass]="{ 'disabled': page.disabled }">
                            {{ getSelectedLayoutLabel(page.selectedLayout) }}
                            <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" style="margin-left:auto" alt="drop-img">
                        </div>
                        <div class="dropdown-menu" *ngIf="!page.disabled && page.dropdownOpen" >
                            <ng-container *ngFor="let layout of layouts; let j = index;"  >
                                <div class="dropdown-item" *ngIf="layout.value !== null" (click)="onLayoutChange(i, layout, j)" >
                                    <div class="radio-container">
                                        <input type="radio" name="type" [value]="layout.value" [checked]="page.layout[j].selected">
                                        <span class="layout-label" [ngClass]="{'selected-dropdown': page.layout[j].selected}">
                                            {{ layout.label }}
                                        </span>
                                    </div>
                                    <div class="image-container">
                                        <!-- <img src="../../../../../assets/ImagesSnapshot/Public/fourWidget_inactive.png" alt="layout-image"> -->

                                        <img [src]="page.layout[j].selected?page.layout[j].activeurl:page.layout[j].url" alt="layout-image">
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
                

            </div>
            <div class="static-text">
                <p style="text-align:center;font-size:0.7rem;">Submitting the snapshot layout will clear the widgets
                    in
                    the preview screen.Please reconfigure the
                    page.</p>
            </div>
        </div>
        <div class="action-buttons popupFooter">
            <!-- [ngClass]="{'disable':!submitEnable}" -->
            <div class="submit-button" [ngClass]="{'disable':!submitEnable}" (click)="SubmitClicked()">
                <img src="../../../../assets/images/common/Icon_load.svg" class="submit-img" alt="submit">
                <span class="btn-text">Submit</span>
            </div>
            <div class="reset-button" (click)="ResetClicked()">
                <img src="../../../../assets/images/common/Icon_reset.svg" class="reset-img" alt="reset">
                <span class="btn-text">Reset</span>
            </div>
        </div>
    </div>
</div>